// Shared auth redirection helpers, used by ProtectedRoute, the global 401
// handler, and the auth forms so the URL-building / target-resolution logic
// lives in one place.

export interface RedirectLocation {
  pathname: string;
  search?: string;
  hash?: string;
  state?: { from?: ReturnTarget };
}

export type ReturnTarget =
  | string
  | { pathname?: string; search?: string; hash?: string };

// Build the /auth URL that carries the original location so the user returns
// there after logging in. Encoded so it survives a refresh on /auth.
export const buildAuthRedirectUrl = (location: RedirectLocation): string => {
  const target = `${location.pathname}${location.search ?? ""}${
    location.hash ?? ""
  }`;
  return `/auth?redirect=${encodeURIComponent(target)}`;
};

// Resolve where to send the user after a successful login / sign-out redirect:
// prefer the location passed via router `state.from`, then a `?redirect=`
// query param, finally the dashboard (a freshly signed-in user is ready to list).
export const resolveReturnTarget = (
  location: RedirectLocation,
  searchParams?: URLSearchParams
): ReturnTarget => {
  const fromState = location?.state?.from;
  if (fromState) return fromState;
  const fromQuery = searchParams?.get?.("redirect");
  return fromQuery || "/dashboard";
};
